"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToXDecimal = void 0;
function roundToXDecimal(decimalNumber, numberOfPlaces) {
    const placementFactor = Math.pow(10, numberOfPlaces);
    return Math.round((decimalNumber + Number.EPSILON) * placementFactor) / placementFactor;
}
exports.roundToXDecimal = roundToXDecimal;
